import React, { createContext, useContext, useState } from 'react';
import api from '../config/api';
import { useAuth } from './AuthContext';

const OrderContext = createContext();

export const useOrder = () => {
    return useContext(OrderContext);
};

export const OrderProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [orders, setOrders] = useState([]);
    const { user } = useAuth();

    const createOrder = async (orderData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await api.post('/orders/create', orderData);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Sipariş oluşturulamadı');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const getOrders = async () => {
        setLoading(true);
        setError(null);
        try {
            if (!user?.cust_id) {
                throw new Error('Kullanıcı girişi yapılmamış');
            }
            const response = await api.get(`/orders/user/${user.cust_id}`);
            setOrders(response.data);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Siparişler getirilemedi');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const getOrderById = async (orderId) => {
        setLoading(true);
        setError(null);
        try {
            const response = await api.get(`/orders/${orderId}`);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Sipariş bulunamadı');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const value = {
        loading,
        error,
        orders,
        createOrder,
        getOrders,
        getOrderById
    };

    return (
        <OrderContext.Provider value={value}>
            {children}
        </OrderContext.Provider>
    );
};

export default OrderContext; 